import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { HiOutlineArrowRight } from "react-icons/hi";
import { impactHighlights, profile } from "../data/portfolio";

function Home2() {
  return (
    <Container fluid className="home-about-section">
      <Container>
        <Row className="g-4 align-items-stretch">
          <Col lg={5} className="scroll-reveal">
            <div className="section-kicker">What I bring</div>
            <h2 className="section-title home-about-title">Work that moves real product numbers.</h2>
            <p className="section-copy">
              I care about the part of engineering you can measure: pages that load faster, apps that crash less,
              checkouts that convert better, and internal tools that quietly save teams money every month.
            </p>
            <a className="soft-link home-mail-link" href={`mailto:${profile.email}`}>
              Start a conversation <HiOutlineArrowRight />
            </a>
          </Col>

          <Col lg={7}>
            <div className="impact-grid">
              {impactHighlights.map((item, index) => (
                <article className="impact-card scroll-reveal" key={item}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <p>{item}</p>
                </article>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
